/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitSecretEncoding
*/
export var KitSecretEncoding;
(function (KitSecretEncoding) {
    KitSecretEncoding["VAULT"] = "VAULT";
    KitSecretEncoding["PLAIN"] = "PLAIN";
    KitSecretEncoding["SERVER"] = "SERVER";
})(KitSecretEncoding || (KitSecretEncoding = {}));
//# sourceMappingURL=KitSecretEncoding.js.map